import { DataModel } from '../models/dto/data-model.js';

export abstract class FormSubmissionAnswer extends DataModel {
  abstract get questionId(): string;
}
